import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from 'hubspot-apollo-client';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { CrmLinksDataProvider } from 'crm-links/common/context/CrmLinksDataProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const client = createApolloClient();
export function ApolloContainer({
  children
}) {
  return /*#__PURE__*/_jsx(ApolloProvider, {
    client: client,
    children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: new DataFetchingClient(),
      children: /*#__PURE__*/_jsx(CrmLinksDataProvider, {
        apolloClient: client,
        children: children
      })
    })
  });
}
export default ApolloContainer;